const BanniereSuperficie = () => {
    return (
        <div className="flex flex-wrap max-w-[90%] md:flex-nowrap mx-auto justify-center py-8 items-center gap-4 md:gap-8 md:py-12 pb-8 md:pb-16">
            <img src="/assets/img/homepage/carte_territoire_intervention.png" className="h-50 w-auto sm:h-64" alt="Carte du territoire d'intervention; de Chaumont-porcien à GrandPré"></img>
            <p className="text-xl"><span className="italic text-3xl font-title block sm:pb-2 xl:pb-0 ">Notre territoire d'intervention sur le Sud Ardennes :</span><br></br> 
                <em>219 communes</em> et <em>60530 habitants !</em><br></br>
                <em>3 communautés de Communes</em> du Sud Ardennes <br></br>(Pays Rethelois, Argonne Ardennaise et Crêtes Préardennaises), </p>
        </div>
    )
}
export default BanniereSuperficie;